import { TranslocoService } from '@jsverse/transloco';
import { Inject, Injectable, Optional } from '@angular/core';
import { NormalizedError } from './error.types';
import { ErrorNotificationService } from './error-notification.service';
import { ERROR_DIALOG_PORT, ErrorDialogPort } from './error.tokens';

@Injectable({ providedIn: 'root' })
export class ErrorPresenter {
    private lastKey = '';
    private lastAt = 0;

    constructor(
        private notify: ErrorNotificationService,
        private readonly transloco: TranslocoService,
        @Optional() @Inject(ERROR_DIALOG_PORT) private dialogPort?: ErrorDialogPort
    ) {}

    present(err: NormalizedError): void {
        const localizedError = this.localize(err);

        // Dedupe (500ms)
        const key = `${localizedError.status}|${localizedError.code}|${localizedError.message}`;
        const now = Date.now();
        if (key === this.lastKey && now - this.lastAt < 500) return;
        this.lastKey = key;
        this.lastAt = now;

        // 1) Snackbar – immer
        this.notify.show(localizedError);

        // 2) Dialog – schwere Fehler
        if (
            this.dialogPort &&
            (localizedError.category === 'network' || (localizedError.status ?? 0) >= 500)
        ) {
            this.dialogPort.open(localizedError, { width: '520px' });
        }
    }

    private localize(err: NormalizedError): NormalizedError {
        const marker = 'i18n:';
        if (!err.message?.startsWith(marker)) {
            return err;
        }

        return {
            ...err,
            message: this.transloco.translate(err.message.slice(marker.length)),
        };
    }
}
